import React, { useEffect, useState } from 'react';
import IntegrationCard from '../JobNimbus/IntegrationCard';
import nimbusLogo from 'assets/images/job-nimbus-logo.png';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import { syncContactData } from 'services/job.service';
import { toast } from 'react-toastify';
import { getApiKey } from 'services/nimbus.service';
import { ArrowLeft } from 'lucide-react';

const Integrations: React.FC = () => {
  const [showSetting, setShowSetting] = useState<boolean>(false);
  const [selectedIntegration, setSelectedIntegration] = useState<string>('');
  const [apiKey, setApiKey] = useState<string>('');
  const [isSyncing, setIsSyncing] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const isSyncing = localStorage.getItem('isSyncing');
    if (isSyncing === 'true') {
      setIsSyncing(true);
    }
  }, []);

  useEffect(() => {
    getApiKey().then((res: any) => {
      if (res) setApiKey(res);
    }).catch((err: any) => err);
  }, []);

  const handleCardClick = (integrationName: string): void => {
    setSelectedIntegration(integrationName);
    setShowSetting(true);
  };

  const handleBackButton = () => {
    setShowSetting(false);
    const syncingStatus = localStorage.getItem('isSyncing');
    if (syncingStatus === 'true') {
      setIsSyncing(true);
    }
  };

  const validationSchema = Yup.object({
    apiKey: Yup.string().required('API Key is required'),
  });

  const initialValues = {
    apiKey: apiKey || '',
  };

  if (showSetting && selectedIntegration === 'JobNimbus') {
    return (
      <div id="setting-detail" className="w-full p-4 sm:p-6">
        <button onClick={handleBackButton} className="mb-5 flex items-center text-gray-600 hover:text-gray-800">
          <ArrowLeft className="mr-1" />
          Back
        </button>
        <div className="w-full max-w-4xl mx-auto bg-white shadow-md rounded-lg p-4 sm:p-6 lg:p-8">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4">Settings</h2>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setLoading(true);
              localStorage.setItem('isSyncing', 'true');
              toast.info("Syncing contact data is in progress...", { autoClose: 2000 });
              syncContactData(values?.apiKey).then(
                () => {
                  getApiKey().then((res: any) => {
                    if (res) setApiKey(res);
                  });
                }
              );
              setLoading(false);
            }}
          >
            {({ errors, touched, isSubmitting }) => (
              <Form className="space-y-6">
                <div className="flex flex-col">
                  <label htmlFor="apiKey" className="block text-sm font-medium text-gray-700 mb-1">
                    API Key
                  </label>
                  <Field
                    name="apiKey"
                    type="text"
                    className="block w-full border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  {errors.apiKey && touched.apiKey && (
                    <div className="text-red-500 text-sm mt-1">{errors.apiKey}</div>
                  )}
                </div>

                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-blue-300"
                  >
                    {isSubmitting ? 'Syncing...' : 'Start Sync'}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  } return (
    <div id="integration-content" className="pl-3 mt-[62px] w-full">
      <h5 className="hidden lg:block">Integrations</h5>
      <p>Connect to your team's favorite tools</p>
      <div className="mt-5">
        <IntegrationCard
          isSyncing={isSyncing}
          logo={nimbusLogo}
          name="JobNimbus"
          category="CRM"
          description="Sync contacts with job nimbus service"
          onClick={() => handleCardClick('JobNimbus')}
        />
      </div>
    </div>
  );
};

export default Integrations;
